/**
 * 使用范围
 * 车辆管理->全部（我的）审批管理,车辆待审批详情页
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
// desc 车辆待审批信息详情-数据
const detailData = {
    goodsId: '',
    rankLevel: '',
    carModelName: '',
    locationName: '',
    carType: '',
    registerName: '',
    factoryDate: '',
    registerDate: '',
    mileage: '',
    license: '',
    vin: '',
    engine: '',
    basePriceWYuan: '',
    buyPriceWYuan: '',
    auctionPriceWYuan: '',
    comment: '',
    reportUrl: '',
    showFooter: false,
};
export default createStore({
    state: Object.assign({ id: '', showDetail: false }, detailData),
    effects: {
        show(isShow, { state }) {
            this.SET_STATE({
                showDetail: isShow,
            });
        },
        // desc 待审批车辆详情-查询详情
        queryDetail(id, { state }) {
            const query = {
                goodsId: id,
            };
            API.goods.getCarInfoByGoodsId(query)
                .then((res) => {
                this.SET_STATE({
                    goodsId: res.goodsId,
                    rankLevel: res.rankLevel,
                    carModelName: res.carModelName,
                    locationName: res.locationName,
                    carType: res.carType,
                    registerName: res.registerName,
                    factoryDate: res.factoryDate,
                    registerDate: res.registerDate,
                    mileage: res.mileage,
                    license: res.license,
                    vin: res.vin,
                    engine: res.engine,
                    basePriceWYuan: res.basePriceWYuan,
                    basePriceYuan: res.basePriceYuan,
                    buyPriceWYuan: res.buyPriceWYuan,
                    buyPriceYuan: res.buyPriceYuan,
                    auctionPriceWYuan: res.auctionPriceWYuan,
                    auctionPriceYuan: res.auctionPriceYuan,
                    comment: res.comment,
                    reportUrl: res.reportUrl,
                    status: res.status,
                    rankDesc: res.rankDesc,
                });
            });
        },
        // desc 重置数据
        resetState(params, { state }) {
            this.SET_STATE(Object.assign({ showDetail: false }, detailData));
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
